import { addLicense, useTheme } from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import React, { Suspense, useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setPageName, setPageTitleDescription } from "../../actions";
import "../../assets/styles/main.scss";
import { __chart_license__ } from "../../constants";
import { BackgroundContext, DocumentationContext } from "../../context";
import LoadingEllipsis from "../Loading/LoadingEllipsis";
import { CedarShellLayout } from "./CedarShell/CedarShellLayout";

interface Props {
  children: JSX.Element;
}

// Every existing dashboard page routes through here. The header/sidenav/release-notes/
// department-prompt/page-tracking chrome now all live in CedarShellLayout (shared with the new
// Home/Favourites/Dashboards/etc. pages) - this component's only remaining job is the legacy
// .dashboard grid wrapper that DefaultPageContent.tsx and friends position their filter
// bars/banners against via named grid-areas ("form"/"banner"). That grid is left completely
// untouched other than zeroing out --menu_width, since the old nav that column was reserved for
// is gone now.
export const DashboardLayout = (props: Props): JSX.Element => {
  const { children } = props;
  const chartLicense: string = __chart_license__ || "";

  const [documentation, setDocumentation] = useState("");
  const [isVisible, setIsVisible] = useState(false);

  const { hideBackgroundImage } = useContext(BackgroundContext);
  const dispatch = useDispatch();

  // Sets chart settings
  useEffect(() => {
    addLicense(chartLicense);
  }, []);

  useEffect(
    () => () => {
      dispatch(setPageName(""));
      dispatch(setPageTitleDescription(""));
    },
    [dispatch]
  );

  useTheme(am4themes_animated);

  return (
    <CedarShellLayout>
      <div className={`pageWrapper ${hideBackgroundImage ? "hide_background" : ""}`} id={"mainDashboard"}>
        <div className="dashboard" id="oceDashboard" style={{ "--menu_width": "0" } as React.CSSProperties}>
          <Suspense fallback={<LoadingEllipsis isLoading={true} />}>
            <DocumentationContext.Provider value={{ documentation, setDocumentation, isVisible, setIsVisible }}>
              {children}
            </DocumentationContext.Provider>
          </Suspense>
        </div>
      </div>
    </CedarShellLayout>
  );
};
